export default __webpack_public_path__ + "images/segment_introduction_background_left.6aa88080b96577d1c85cd64f62811af8.svg";